import { render, staticRenderFns } from "./StartSlide.vue?vue&type=template&id=0532c07a&scoped=true&"
import script from "./StartSlide.vue?vue&type=script&lang=js&"
export * from "./StartSlide.vue?vue&type=script&lang=js&"
import style0 from "./StartSlide.vue?vue&type=style&index=0&id=0532c07a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0532c07a",
  null
  
)

export default component.exports